const floatingChatStyles = `
.floating-chat {
	/* The window chrome (head + drawer) lives outside .ai-ws, where the --ws-* theme vars
	   aren't defined — without these the drawer's background resolves to transparent and the
	   page bleeds through. Mirror the values from workspaceStyles' .ai-ws block. */
	--ws-panel: #ffffff;
	--ws-soft: #edf1f5;
	--ws-hover: #e9eef3;
	--ws-line: #e4eaf0;
	--ws-ink: #2f3947;
	--ws-ink-2: #3e4957;
	--ws-r-sm: 6px;
	--ws-sans: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;

	position: relative;
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	background: var(--ws-panel);
	/* Rounding, the hairline ring, the drop shadow and the rounded clip live on the draggable
	   wrapper (the element react-draggable transforms), NOT here — see FloatingAIChat.tsx. A
	   rounded overflow clip on a descendant of a transformed element is mis-composited by
	   Chromium and leaks square corners. The plain (square) containment clip for the chat's
	   own children lives here; the wrapper applies the rounded corners. clip, not hidden —
	   hidden is still programmatically scrollable (the closed drawer's translateX(100%)
	   leaves scrollable overflow) and scrollIntoView/focus would shift the window content. */
	overflow: hidden;
	overflow: clip;
}
.floating-chat-head {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding: 6px 8px;
	border-bottom: 1px solid var(--ws-line);
	cursor: move;
	user-select: none;
	/* No own background: .floating-chat is white and rounded, and the overflow clip is
	   unreliable on the header's top corners under react-draggable's transformed ancestor
	   (it leaves them square). With a transparent header the rounded parent white shows at
	   the corners — nothing square to clip. The header only contributes its bottom divider. */
	background: transparent;
	flex: 0 0 auto;
}
.floating-chat-actions { display: flex; gap: 2px; }
.floating-chat-body { flex: 1; min-height: 0; display: flex; }
.floating-chat-body .ai-ws-embed { width: 100%; height: 100%; }
/* The shared workspace styles hardcode height:100vh on .ai-ws/.ws-main (correct for the
   full-screen workspace + extension panel, wrong inside this small window) — that pushed
   the message thread + composer off-screen below the window, leaving it blank. Override
   to fill the window instead. */
.floating-chat .ai-ws { display: flex; height: 100%; min-height: 0; }
.floating-chat .ws-main { height: 100%; min-height: 0; flex: 1; }
/* Conversation drawer — slides over the window (anchored to .floating-chat, not the
   viewport like the extension panel's .embed-drawer). Reuses the .embed-drawer-head /
   .embed-new-chat / .embed-conv-* internals from embedStyles. */
.floating-drawer {
	position: absolute;
	inset: 0;
	z-index: 5;
	display: flex;
	flex-direction: column;
	background: var(--ws-panel);
	transform: translateX(100%);
	transition: transform 0.2s ease;
	font-family: var(--ws-sans);
}
.floating-drawer.is-open { transform: translateX(0); }
`;

export default floatingChatStyles;
